import { Divider } from 'antd';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

import OtherAppSmash from '../../../../assets/icons/OtherAppSmash';
import VimeoSvg from '../../../../assets/icons/VimeoSvg';
import YoutubeSvg from '../../../../assets/icons/YoutubeSvg';
import { IconWrapper } from '../../../_atoms/IconWrapper';

export type IframeAppSmash = 'youtube' | 'nrk' | 'vimeo' | 'other' | 'screencastify';

const InstructionsContainer = styled.div`
  width: 100%;
  height: 200px;
  padding-top: 20px;
  & p {
    margin-bottom: 2px;
  }

  & li {
    font-weight: bold;
  }

  & video {
    border-radius: 5px;
  }
`;

export const appSmashes: {
  id: IframeAppSmash;
  icon: React.ReactNode;
  instructions?: React.ReactNode;
  placeholder: string;
}[] = [
  {
    id: 'youtube',
    placeholder: 'Youtube',
    icon: (
      <IconWrapper height="40px" width="40px" color="#FF0000">
        <YoutubeSvg />
      </IconWrapper>
    ),
    instructions: (
      <InstructionsContainer>
        <p>Mini tutorial</p>
        <ol>
          <li>Find your Youtube video</li>
          <li>Copy the link from the url</li>
          <li>Paste it here :)</li>
        </ol>
      </InstructionsContainer>
    ),
  },

  {
    id: 'vimeo',
    placeholder: 'Vimeo',
    icon: <VimeoSvg />,
  },
  {
    id: 'other',
    placeholder: 'Other',
    icon: <OtherAppSmash />,
    instructions: (
      <InstructionsContainer>
        <p>Embed videos from</p>
        <ul>
          <li>Screencastify</li>
          <li>Google Drive</li>
          <li>NRK</li>
        </ul>

        <p>Missing one from the list? Let us know!</p>

        <Divider />
        <InstructionsContainer style={{ padding: 0 }}>
          <p>Nrk tutorial</p>
          <div style={{ width: '100%', height: 174 }}>
            <ReactPlayer
              style={{ borderRadius: 5 }}
              controls
              url={'/static/nrktutorial.mp4'}
              height={174}
              width="100%"
            />
          </div>
        </InstructionsContainer>
      </InstructionsContainer>
    ),
  },
];
